import * as actionTypes from "./constants";

const initialState = {
  processing: false,
  error: false,
  currentAlertList: [],
  alertHistoryList: [],
  alertHistoryCount: 0,
  currentAlertCount: 0,
};

export default function AlertsbReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_CURRENT_ALERT_INIT_ACTION:
      return {
        ...state,
        currentAlertLoader: true,
        currentAlertList: [],
        currentAlertCount: 0,
      };
    case actionTypes.FETCH_CURRENT_ALERT_SUCCESS_ACTION:
      return {
        ...state,
        currentAlertLoader: false,
        currentAlertList: action?.payload?.response_data?.alerts || [],
        currentAlertCount: action?.payload?.count || 0,
      };
    case actionTypes.FETCH_CURRENT_ALERT_FAIL_ACTION:
      return {
        ...state,
        currentAlertLoader: false,
        currentAlertList: [],
        currentAlertCount: 0,
      };
    case actionTypes.FETCH_ALERT_HISTORY_INIT_ACTION:
      return {
        ...state,
        alertHistoryLoader: true,
        alertHistoryList: [],
        alertHistoryCount: 0,
      };
    case actionTypes.FETCH_ALERT_HISTORY_SUCCESS_ACTION:
      return {
        ...state,
        alertHistoryLoader: false,
        alertHistoryList: action?.payload?.response_data?.alerts || [],
        alertHistoryCount: action?.payload?.response_data?.TotalCount || 0,
      };
    case actionTypes.FETCH_ALERT_HISTORY_FAIL_ACTION:
      return {
        ...state,
        alertHistoryLoader: false,
        alertHistoryList: [],
        alertHistoryCount: 0,
      };
      case actionTypes.FETCH_APT_SUCCESS_ACTION:
        return {
          ...state,
          SupportAddAptList: action.payload.response_data.aptList,
        };
    default:
      return {
        ...state,
      };
  }
}
